import {createBrowserHistory, createMemoryHistory} from 'history';

const createHistory = ({server = false, basename, useMemoryHistory = false}) => {
    return server || useMemoryHistory ? createMemoryHistory({basename}) : createBrowserHistory({basename});
};

export default createHistory;
